import { __decorate } from "tslib";
import { cloneDeep } from "lodash-es";
import { State } from 'vue-class-state';
import { BaseState } from "../state/BaseState";
import { StateDefine } from "../state/utils/StateDefine";
import { getAllDataSchema, getListDataSchema, getSelectedItemsSchema, pageSchema, sizeSchema, totalSchema } from "../stateCommon/list";
import { bodyFilterField, bodySortField } from "../templates/apis/list";
import { NotEnumerable } from "../../tools/enumerable";
import { StateProxy } from "./utils/defineProxyState";
export class ListStateJS extends BaseState {
  constructor(collection, options) {
    super(collection, options);
    this.stateModel = 'list_JS';
    /**
     * 给本地分页使用的，存放所有数据
     */
    this.allData = [];
    this.listData = [];
    this.page = 1;
    this.size = 20;
    this.filter = [];
    this.sort = [];
    this.total = 0;
    this.selectedItems = [];
    this.initState();
  }
  get ucTag() {
    var _this$options$sourceC;
    return ((_this$options$sourceC = this.options.sourceConfig) === null || _this$options$sourceC === void 0 ? void 0 : _this$options$sourceC.usage) === 'local' ? '列表-本地分页' : '列表';
  }
}
ListStateJS.stateModel = 'list_JS';
__decorate([StateDefine(getAllDataSchema), NotEnumerable], ListStateJS.prototype, "allData", void 0);
__decorate([StateDefine(getListDataSchema(false)), StateProxy], ListStateJS.prototype, "listData", void 0);
__decorate([StateDefine(pageSchema), State], ListStateJS.prototype, "page", void 0);
__decorate([StateDefine(sizeSchema), State], ListStateJS.prototype, "size", void 0);
__decorate([StateDefine(() => {
  const schema = cloneDeep(bodyFilterField);
  return schema;
}), State], ListStateJS.prototype, "filter", void 0);
__decorate([StateDefine(bodySortField), State], ListStateJS.prototype, "sort", void 0);
__decorate([StateDefine(totalSchema), State], ListStateJS.prototype, "total", void 0);
__decorate([StateDefine(getSelectedItemsSchema), State], ListStateJS.prototype, "selectedItems", void 0);
//# sourceMappingURL=ListStateJS.js.map
